export default __webpack_public_path__ + "static/media/img8.17d19ada.png";